module.exports = __webpack_public_path__ + "static/img/15.0f1786d7.jpeg";